import { object, bool, array, node } from 'prop-types'

import Filter from './Filter'
import { css } from '@emotion/react'
import {
  DesignToken,
  SpacingToken,
} from '@livechat/design-system-react-components'
import Sort from './Sort'

const contentWrapperCss = (showEntireHeader, isAllApps) =>
  css`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: var(${SpacingToken.Spacing3});
    border-bottom: 1px solid var(${DesignToken.BorderBasicTertiary});
    ${showEntireHeader && `margin-top: var(${SpacingToken.Spacing4});`}
    ${showEntireHeader &&
    `border-top: 1px solid var(${DesignToken.BorderBasicTertiary});`}
    ${!showEntireHeader &&
    `padding: var(${
      isAllApps ? SpacingToken.Spacing4 : SpacingToken.Spacing6
    }) 0;`}
  `

const filtersListCss = (showEntireHeader) => css`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  max-width: 100%;
  ${showEntireHeader && `padding: var(${SpacingToken.Spacing5}) 0;`}
  gap: var(${SpacingToken.Spacing3});
`

const sortListCss = css`
  display: flex;
  flex-wrap: wrap;
  gap: var(${SpacingToken.Spacing3});
`

export const Content = ({
  showEntireHeader,
  isAllApps,
  filters,
  sort,
  children,
}) => {
  return (
    <div css={contentWrapperCss(showEntireHeader, isAllApps)}>
      <div css={filtersListCss(showEntireHeader)}>
        {filters?.map((filter) => (
          <Filter key={filter.id} {...filter} />
        ))}
      </div>

      <div css={sortListCss}>
        {children}
        {sort && !showEntireHeader && <Sort {...sort} />}
      </div>
    </div>
  )
}

Content.propTypes = {
  showEntireHeader: bool,
  isAllApps: bool,
  filters: array,
  sort: object,
  children: node,
}
